import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  flex-shrink: 0;\n  justify-content: center;\n  list-style: none;\n  margin: '24px 0 0';\n  padding: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { CarouselDot } from './CarouselDot';
var StyledDots = styled.ul.attrs({
  role: 'tablist'
})(_templateObject());
export var CarouselDots = function CarouselDots(_ref) {
  var activeIndex = _ref.activeIndex,
      items = _ref.items,
      onPageChange = _ref.onPageChange;
  var dots = [];

  if (items.length <= 1) {
    return null;
  }

  for (var i = 0; i < items.length; i++) {
    dots.push(React.createElement("li", {
      key: items[i]
    }, React.createElement(CarouselDot, {
      id: items[i],
      dotIndex: i,
      activeIndex: activeIndex,
      onPageChange: onPageChange
    })));
  }

  return React.createElement(StyledDots, null, dots);
};